import { render } from "./GridContactDetalii.vue?vue&type=template&id=03034870&scoped=true&ts=true"
import script from "./GridContactDetalii.vue?vue&type=script&lang=ts"
export * from "./GridContactDetalii.vue?vue&type=script&lang=ts"

import "./GridContactDetalii.vue?vue&type=style&index=0&id=03034870&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03034870"]])

export default __exports__